<template>
  <div>
    <div class="fixed inset-0 bg-blue-800"></div>
  
    <div class="navbar-top">
      <div class="header-wrapper">
        <div class="flex justify-center items-center">
  
        </div>
        <div class="flex justify-center items-center">
          <img src="/fc_logo.svg" class="h-8" alt="FC logo">
        </div>
        <div class="flex justify-center items-center">
  
        </div>
      </div>
    </div>
    
    <div class="wrapper has-navbar-top fixed inset-0">
      <div class="flex flex-col p-6 md:px-3">
        <div class="pb-8 text-white">
          <h1 class="text-5xl">404</h1>
          <p class="mb-10">Такой страницы не существует :(</p>
          <p class="mb-4">Попробуйте добраться до цели через главное меню:</p>
          <router-link :to="{ name: 'PageDashboard' }"
                       class="px-4 py-2 rounded bg-blue-600 font-bold text-white">В главное меню</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  
};
</script>

<style scoped>
</style>
